module.exports = "pegasus/assets/themelp1/basic/101.png";